module.exports = __webpack_public_path__ + "static/media/icon_provisioned.a6d3a9aa.svg";